<template>
  <div id="30_main">
    <v-row>
      <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
      <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    </v-row>

    <v-card>
      <v-card-title>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="getMainTableData()">mdi-update</v-icon>
          </template>
          <span>Поновити таблицю</span>
        </v-tooltip>
        
        <v-spacer></v-spacer>
        Клієнти.
        <v-spacer></v-spacer>

        <v-text-field
          v-model="mainTableSearch"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="mainTableHeaders"
        :items="mainTableItems"
        :search="mainTableSearch"
        :items-per-page="10"
        dense
        multi-sort
      > 
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="item.color"
            dark
          >
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click.stop="dialogKlientOpen(item.id)">mdi-account-edit</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        errorMessage: '',
        errorAlertShow: false,
        progresLineShow: false,
        mainTableItems: [],
        mainTableHeaders: [
          { text: 'Клієнт' , value: 'pib' },
          { text: 'Нас.П.', value: 'nasp' },
          { text: 'Вулиця', value: 'street' },
          { text: 'Будинок', value: 'building' },
          { text: 'Квартира', value: 'kv' },
          { text: 'Телефон', value: 'tel' },
          { text: 'Модель', value: 'model' },
          { text: 'Дата пуску', value: 'datp' },
          { text: '', value: 'actions', sortable: false },
        ],
        mainTableSearch: '',
        
      }
    },
    watch: {
      
    },
  methods: {
      getMainTableData () {
        this.progresLineShow = true
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '30',
            ww: '1',
            pp: localStorage.pp,
            pn: localStorage.pn,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then((data) => {
          if (!data.ok) {
            const error = (data && data.message) || data.status
            return Promise.reject(error)
          }
          return data
        })
        .then((data) => data.json())
        .then((data) => {
          if (data.isauth == true) {
            this.mainTableItems = data.tablelist
            this.progresLineShow = false
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error
          this.progresLineShow = false
          this.errorAlertShow = true
        });
      },
      dialogKlientOpen (item) {
        console.log(item)
      },

    },
    computed: {
      
    },
  created: function () {
      this.getMainTableData()
    },
  }
</script>